import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const VirtualCurrencyPage = () => {
  const navigate = useNavigate();
  const { user, meritPoints, updateMeritPoints } = useUser();
  
  const [activeTab, setActiveTab] = useState('about');
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // 如果用户未登录，重定向到登录页面
  useEffect(() => {
    if (!user) {
      navigate('/login');
    } else {
      // 加载交易历史（模拟）
      setTimeout(() => {
        const mockTransactions = [
          {
            id: 'tx123456',
            type: 'income',
            amount: 50,
            description: '完成"每日冥想"任务',
            timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString()
          },
          {
            id: 'tx123455',
            type: 'expense',
            amount: 100,
            description: '购买"筑基丹"',
            timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString()
          }
        ];
        
        setTransactions(mockTransactions);
        setLoading(false);
      }, 1000);
    }
  }, [user, navigate]);
  
  // 格式化日期时间
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit',
      hour: '2-digit', 
      minute: '2-digit'
    });
  };
  
  return (
    <div className="space-y-8">
      {/* 功德点系统头部 */}
      <section className="cyber-panel p-6 rounded-lg bg-gradient-to-r from-cyber-dark to-black">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div>
            <h1 className="text-3xl font-xianxia text-cyber-primary mb-2 cyber-title">功德点系统</h1>
            <p className="text-cyber-light">
              天道宗加密数字货币，修真与科技的融合
            </p>
          </div>
          
          <div className="mt-4 md:mt-0 text-right">
            <div className="text-cyber-accent text-2xl font-cyber mb-1">
              {meritPoints} <span className="text-sm">功德点</span>
            </div>
          </div>
        </div>
      </section>
      
      {/* 标签导航 */}
      <div className="border-b border-cyber-primary">
        <nav className="flex flex-wrap -mb-px">
          <button
            className={`mr-8 py-2 border-b-2 font-medium text-sm ${
              activeTab === 'about'
                ? 'border-cyber-primary text-cyber-primary'
                : 'border-transparent text-cyber-light hover:text-cyber-secondary hover:border-cyber-secondary'
            }`}
            onClick={() => setActiveTab('about')}
          >
            功德点介绍
          </button>
          <button
            className={`mr-8 py-2 border-b-2 font-medium text-sm ${
              activeTab === 'history'
                ? 'border-cyber-primary text-cyber-primary'
                : 'border-transparent text-cyber-light hover:text-cyber-secondary hover:border-cyber-secondary'
            }`}
            onClick={() => setActiveTab('history')}
          >
            交易记录
          </button>
        </nav>
      </div>
      
      {/* 标签内容 */}
      <div className="tab-content">
        {/* 功德点介绍 */}
        {activeTab === 'about' && (
          <div className="cyber-panel p-6 rounded-lg">
            <h2 className="text-2xl font-cyber text-cyber-primary mb-6">
              关于功德点
            </h2>
            
            <div className="space-y-6">
              <p className="text-cyber-light">
                功德点是天道宗基于区块链技术开发的宗门内部数字货币，融合了传统修真中的"功德"概念与现代加密货币技术。
                功德点可用于兑换各种修炼资源、法器、丹药，以及支付线下道场的各种服务费用。
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="cyber-panel p-4 rounded">
                  <div className="text-3xl text-cyber-accent mb-3">
                    <i className="fas fa-coins"></i>
                  </div>
                  <h3 className="text-lg text-cyber-secondary mb-2">获取方式</h3>
                  <ul className="text-cyber-light text-sm space-y-2">
                    <li>• 完成宗门任务</li>
                    <li>• 参与线下活动</li>
                    <li>• 为其他道友提供帮助</li>
                  </ul>
                </div>
                
                <div className="cyber-panel p-4 rounded">
                  <div className="text-3xl text-cyber-accent mb-3">
                    <i className="fas fa-shopping-cart"></i>
                  </div>
                  <h3 className="text-lg text-cyber-secondary mb-2">使用场景</h3>
                  <ul className="text-cyber-light text-sm space-y-2">
                    <li>• 购买丹药和法器</li>
                    <li>• 兑换修炼资源</li>
                    <li>• 线下道场服务付款</li>
                  </ul>
                </div>
                
                <div className="cyber-panel p-4 rounded">
                  <div className="text-3xl text-cyber-accent mb-3">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <h3 className="text-lg text-cyber-secondary mb-2">技术特点</h3>
                  <ul className="text-cyber-light text-sm space-y-2">
                    <li>• 基于区块链技术</li>
                    <li>• 高安全性加密</li>
                    <li>• 透明的交易历史</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* 交易记录 */}
        {activeTab === 'history' && (
          <div className="cyber-panel p-6 rounded-lg">
            <h2 className="text-2xl font-cyber text-cyber-primary mb-6">
              交易记录
            </h2>
            
            {loading ? (
              <div className="text-center py-12">
                <div className="text-cyber-primary text-3xl mb-4">
                  <i className="fas fa-spinner fa-spin"></i>
                </div>
                <p className="text-cyber-light">加载交易记录中...</p>
              </div>
            ) : transactions.length === 0 ? (
              <div className="text-center py-12">
                <div className="text-cyber-accent text-5xl mb-4">
                  <i className="fas fa-scroll"></i>
                </div>
                <p className="text-cyber-light">暂无交易记录</p>
              </div>
            ) : (
              <div className="space-y-4">
                {transactions.map((transaction) => (
                  <div key={transaction.id} className="cyber-panel p-4 rounded">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 ${
                          transaction.type === 'income' ? 'bg-green-900' : 'bg-red-900'
                        }`}>
                          <i className={`fas ${
                            transaction.type === 'income' ? 'fa-arrow-down' : 'fa-arrow-up'
                          } text-${transaction.type === 'income' ? 'green' : 'red'}-400`}></i>
                        </div>
                        <div>
                          <div className="text-cyber-light">{transaction.description}</div>
                          <div className="text-xs text-cyber-secondary">{formatDateTime(transaction.timestamp)}</div>
                        </div>
                      </div>
                      <div className={`text-xl ${
                        transaction.type === 'income' ? 'text-green-400' : 'text-red-400'
                      }`}>
                        {transaction.type === 'income' ? '+' : '-'}{transaction.amount}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default VirtualCurrencyPage;
